import React, { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { roleCheck } from "utils/index"
import { Container } from "react-bootstrap"
import FilterDropdown from "components/FilterDropdown"
import SearchInput from "components/SearchInput"
import Loader from "components/Loader"
import AnchorButton from "components/AnchorButton"
import { get } from "lodash";
import {
  VIRTUAL_DRAFTING,
  VIRTUAL_DRAFTING_MANAGER
} from "utils/constants"
import { getJobServicesVirtualDrafting } from "requesters/jobServiceRequester"
import { getVrDraftsmen } from "requesters/userRequester"
import { getFilteredProducts } from "requesters/productRequester"
import { getBaseUrl, getCurrentRole, getCurrentUser } from "../../reducers";
import JobServicesByVrDraftsmanTable from "./JobServicesByVrDraftsmanTable";

const VirtualDrafting = () => {
  const baseUrl = useSelector(getBaseUrl)
  const currentUser = useSelector(getCurrentUser)
  const systemRole = currentUser.attributes.role
  const currentTeamRole = currentUser.attributes.current_team_role
  const currentRole = useSelector(getCurrentRole)
  const isVirtualDrafting = roleCheck(systemRole, currentRole, VIRTUAL_DRAFTING)
  const isVirtualDraftingManager = roleCheck(systemRole, currentTeamRole, VIRTUAL_DRAFTING_MANAGER)
  const canAccess = isVirtualDrafting

  if (!canAccess) window.location = "/"

  const initialFilters = {
    by_job_type: undefined,
    by_vr_draftsman: isVirtualDraftingManager ? undefined : currentUser.id,
    by_keyword: undefined
  }
  const [filters, setFilters] = useState(initialFilters)
  const [requesting, setRequesting] = useState(false)
  const [virtualDraftingJobServices, setVirtualDraftingJobServices] = useState([])
  const [jobTypeOptions, setJobTypeOptions] = useState([])
  const [vrDraftsmanOptions, setVrDraftsmanOptions] = useState([])
  const [dropdownFiltersChanged, setDropdownFiltersChanged] = useState(false)

  const fetchData = () => {
    setRequesting(true)
    getJobServicesVirtualDrafting(baseUrl, filters)
    .then(res => {
      if (res.status === 200) {
        const jobServices = get(res, "response", {})
        setVirtualDraftingJobServices(jobServices)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  const fetchJobTypeOptions = () => {
    getFilteredProducts(baseUrl, "virtual-drafting")
    .then(res => {
      if (res.status === 200) {
        const products = Object.values(_.get(res.response, "product", {}))
        const allJobTypes = products.map(js => ([js.attributes.name, js.id]))
        setJobTypeOptions(allJobTypes)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
  }

  const fetchVrDraftsmanOptions = () => {
    getVrDraftsmen(baseUrl)
    .then(res => {
      if (res.status === 200) {
        const options = res.response.map(item => {
          const { label, value, ...other } = item
          return [`${label}`, `${value}`, { ...other }]
        })
        setVrDraftsmanOptions(options)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
  }

  const onSearch = e => {
    e.preventDefault()
    fetchData()
  }

  const onSetFilters = (key, val) => {
    const newFilters = { ...filters }
    newFilters[key] = val
    setFilters(newFilters)
    if (key !== "by_keyword") {
      setDropdownFiltersChanged(true)
    }
  }

  const getFilterName = (key, options) => {
    const selectedOption = options.find(o => o[1] === filters[key])
    const filteredName = selectedOption ? selectedOption[0] : ""

    return filteredName
  }

  useEffect(() => {
    fetchData()
    fetchJobTypeOptions()
    fetchVrDraftsmanOptions()
  }, [])

  useEffect(() => {
    if (dropdownFiltersChanged) {
      fetchData()
      setDropdownFiltersChanged(false)
    }
  }, [dropdownFiltersChanged])

  return (
    <Container fluid className="">
      <div className="container-inner">
        <div className="d-flex justify-content-between align-items-center header-tabs-container">
          <div className="header-tabs">
            <h1>VIRTUAL DRAFTING</h1>
          </div>
          <div className="header-buttons">
          </div>
        </div>
        <div className="table-listing-filters d-md-flex justify-content-between">
          <div>
            <div className="btn-group mr-2">
              <SearchInput
                value={filters.by_keyword}
                setValue={val => onSetFilters("by_keyword", val)}
                handleSubmit={onSearch}
                disableSubmit={requesting} />
            </div>
            <div className="btn-group mr-2">
              <FilterDropdown
                title="Job Type"
                filteredName={getFilterName("by_job_type", jobTypeOptions)}
                setFilter={val => onSetFilters("by_job_type", val)}
                options={jobTypeOptions} />
            </div>
            { isVirtualDraftingManager && (
              <div className="btn-group mr-2">
                <FilterDropdown
                  title="VR Draftsman"
                  filteredName={getFilterName("by_vr_draftsman", vrDraftsmanOptions)}
                  setFilter={val => onSetFilters("by_vr_draftsman", val)}
                  options={vrDraftsmanOptions} />
              </div>
            )}
            <div className="btn-group">
              <AnchorButton
                className="f-small"
                onClick={() => {
                  setFilters(initialFilters)
                  setDropdownFiltersChanged(true)
                }}>
                Clear Filters
              </AnchorButton>
            </div>
          </div>
        </div>
        { requesting ? <Loader />
          : (
            <JobServicesByVrDraftsmanTable
              jobServices={virtualDraftingJobServices}
              setJobServices={setVirtualDraftingJobServices}
              reloadData={fetchData} />
          )}
      </div>
    </Container>
  )
}

export default VirtualDrafting